<template>
    <div class="wrapper">
        <span>{{title}}</span>
    </div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style scoped lang="less">
    .wrapper{
        width: 100%;
        margin-top: 15px;
        padding-left: 14px;
        font-size: 18px;
        font-weight:800;
        color:rgba(65,65,65,1);
    }
</style>